package com.narbase.letsgo.web.routing

import com.narbase.letsgo.models.roles.AdminPrivilege
import com.narbase.letsgo.router.Authentication
import com.narbase.letsgo.router.IpLockInterceptor
import com.narbase.letsgo.router.Routing
import com.narbase.letsgo.web.routing.AdminRouting.route
import com.narbase.letsgo.web.routing.domain.admin.areas.GetAreasEndpoint
import com.narbase.letsgo.web.routing.domain.admin.auditlog.GetAuditLogEndpoint
import com.narbase.letsgo.web.routing.domain.admin.bankilytransfers.AssignTransferToDriverEndpoint
import com.narbase.letsgo.web.routing.domain.admin.bankilytransfers.GetBankilyTransfersEndpoint
import com.narbase.letsgo.web.routing.domain.admin.banners.DeleteBannerEndpoint
import com.narbase.letsgo.web.routing.domain.admin.banners.GetBannersEndpoint
import com.narbase.letsgo.web.routing.domain.admin.banners.UpsertBannerEndpoint
import com.narbase.letsgo.web.routing.domain.admin.callcenter.RegisterPassengerByCallCenterEndpoint
import com.narbase.letsgo.web.routing.domain.admin.cartypes.GetCarTypesEndpoint
import com.narbase.letsgo.web.routing.domain.admin.currencies.GetCurrenciesEndpoint
import com.narbase.letsgo.web.routing.domain.admin.currencyincentiveconfigs.GetCurrencyIncentiveConfigsEndpoint
import com.narbase.letsgo.web.routing.domain.admin.currencyincentiveconfigs.UpsertCurrencyIncentiveConfigsEndpoint
import com.narbase.letsgo.web.routing.domain.admin.drivergroups.GetDriverGroupsByDriverEndpoint
import com.narbase.letsgo.web.routing.domain.admin.drivergroups.GetDriverGroupsEndpoint
import com.narbase.letsgo.web.routing.domain.admin.drivergroups.UpsertDriverGroupEndpoint
import com.narbase.letsgo.web.routing.domain.admin.driverprofilegroup.GetDriverProfileGroupsEndpoint
import com.narbase.letsgo.web.routing.domain.admin.driverprofilegroup.UpsertDriverProfileGroupEndpoint
import com.narbase.letsgo.web.routing.domain.admin.drivers.GetDriverByPhoneEndpoint
import com.narbase.letsgo.web.routing.domain.admin.drivers.GetDriversListEndpoint
import com.narbase.letsgo.web.routing.domain.admin.drivers.UpsertDriverEndpoint
import com.narbase.letsgo.web.routing.domain.admin.drivertargets.GetTargetsEndpoint
import com.narbase.letsgo.web.routing.domain.admin.drivertargets.UpsertTargetEndpoint
import com.narbase.letsgo.web.routing.domain.admin.dynamicroles.DeleteAdminDynamicRoleEndpoint
import com.narbase.letsgo.web.routing.domain.admin.dynamicroles.GetAdminDynamicRolesEndpoint
import com.narbase.letsgo.web.routing.domain.admin.dynamicroles.UpsertAdminDynamicRolesEndpoint
import com.narbase.letsgo.web.routing.domain.admin.favoritepoints.CreateFavoritePointEndpoint
import com.narbase.letsgo.web.routing.domain.admin.favoritepoints.GetFavoritePointsSearchStatusEndpoint
import com.narbase.letsgo.web.routing.domain.admin.favoritepoints.ReindexFavoritePointsSearchEndpoint
import com.narbase.letsgo.web.routing.domain.admin.favoritepoints.DeleteFavoritePointEndpoint
import com.narbase.letsgo.web.routing.domain.admin.favoritepoints.GetPassengerFavoritePointsEndpoint
import com.narbase.letsgo.web.routing.domain.admin.pushpayload.GetPushSendHistoryEndpoint
import com.narbase.letsgo.web.routing.domain.admin.pushpayload.SendPushPayloadEndpoint
import com.narbase.letsgo.web.routing.domain.admin.geocode.GetGeocodeEndpoint
import com.narbase.letsgo.web.routing.domain.admin.incentives.GetConfigEndpoint
import com.narbase.letsgo.web.routing.domain.admin.linkshare.GetLinkShareLogsEndpoint
import com.narbase.letsgo.web.routing.domain.admin.voiceassistant.CheckVoiceAssistantMcpHealthEndpoint
import com.narbase.letsgo.web.routing.domain.admin.voiceassistant.CheckVoiceAssistantModelsHealthEndpoint
import com.narbase.letsgo.web.routing.domain.admin.voiceassistant.TestVoiceAssistantEngineEndpoint
import com.narbase.letsgo.web.routing.domain.admin.voiceassistant.ListVoiceAssistantProviderModelsEndpoint
import com.narbase.letsgo.web.routing.domain.admin.voiceassistant.GetVoiceAssistantSessionAudioEndpoint
import com.narbase.letsgo.web.routing.domain.admin.voiceassistant.GetVoiceAssistantSessionsEndpoint
import com.narbase.letsgo.web.routing.domain.admin.analytics.GetAnalyticsSettingsEndpoint
import com.narbase.letsgo.web.routing.domain.admin.analytics.UpsertAnalyticsSettingsEndpoint
import com.narbase.letsgo.web.routing.domain.admin.voiceassistant.GetVoiceAssistantSettingsEndpoint
import com.narbase.letsgo.web.routing.domain.admin.voiceassistant.UpsertVoiceAssistantSettingsEndpoint
import com.narbase.letsgo.web.routing.domain.admin.linkshare.GetLinkShareTopLinksEndpoint
import com.narbase.letsgo.web.routing.domain.admin.linkshare.SetLinkShareRewardsDisabledEndpoint
import com.narbase.letsgo.web.routing.domain.admin.linkshare.GetLinkShareRewardSettingsEndpoint
import com.narbase.letsgo.web.routing.domain.admin.linkshare.SetLinkShareRewardSettingActiveEndpoint
import com.narbase.letsgo.web.routing.domain.admin.linkshare.UpsertLinkShareRewardSettingEndpoint
import com.narbase.letsgo.web.routing.domain.admin.incentives.GetOrderingIncentivesEndpoint
import com.narbase.letsgo.web.routing.domain.admin.incentives.UpsertConfigEndpoint
import com.narbase.letsgo.web.routing.domain.admin.incentives.UpsertOrderingIncentivesEndpoint
import com.narbase.letsgo.web.routing.domain.admin.locationpoints.GetHistoryPointsEndpoint
import com.narbase.letsgo.web.routing.domain.admin.locationpoints.GetPassengerLocationPointsEndpoint
import com.narbase.letsgo.web.routing.domain.admin.login.AdminLoginEndpoint
import com.narbase.letsgo.web.routing.domain.admin.login.GetAdminProfileDetailsEndpoint
import com.narbase.letsgo.web.routing.domain.admin.mobileupdate.GetMobileUpdateConfigEndpoint
import com.narbase.letsgo.web.routing.domain.admin.mobileupdate.UpsertMobileUpdateConfigEndpoint
import com.narbase.letsgo.web.routing.domain.admin.passengerlocation.GetPassengerLocationEndpoint
import com.narbase.letsgo.web.routing.domain.admin.passengerprofilegroup.GetPassengerProfileGroupsEndpoint
import com.narbase.letsgo.web.routing.domain.admin.passengerprofilegroup.UpsertPassengerProfileGroupEndpoint
import com.narbase.letsgo.web.routing.domain.admin.passengers.*
import com.narbase.letsgo.web.routing.domain.admin.passengers.phonenumbers.DeletePassengerPhoneNumberEndpoint
import com.narbase.letsgo.web.routing.domain.admin.passengers.phonenumbers.GetPassengerPhoneNumbersEndpoint
import com.narbase.letsgo.web.routing.domain.admin.placetype.GetPlaceTypesEndpoint
import com.narbase.letsgo.web.routing.domain.admin.pointofinterest.GetAreaPointsOfInterestEndpoint
import com.narbase.letsgo.web.routing.domain.admin.pointofinterest.GetPointsOfInterestSearchStatusEndpoint
import com.narbase.letsgo.web.routing.domain.admin.pointofinterest.SearchPointsOfInterestEndpoint
import com.narbase.letsgo.web.routing.domain.admin.pointofinterest.GetNearbyPointsOfInterestEndpoint
import com.narbase.letsgo.web.routing.domain.admin.pointofinterest.ReindexPointsOfInterestSearchEndpoint
import com.narbase.letsgo.web.routing.domain.admin.pointofinterest.UpdateElasticsearchSettingsEndpoint
import com.narbase.letsgo.web.routing.domain.admin.price.GetRidePricesEndpoint
import com.narbase.letsgo.web.routing.domain.admin.rides.*
import com.narbase.letsgo.web.routing.domain.admin.ridepromocodes.DeactivateRidePromoCodeEndpoint
import com.narbase.letsgo.web.routing.domain.admin.ridepromocodes.GetActivePromoCodesEndpoint
import com.narbase.letsgo.web.routing.domain.admin.ridepromocodes.GetRidePromoCodesEndpoint
import com.narbase.letsgo.web.routing.domain.admin.ridepromocodes.RedeemRidePromoCodeEndpoint
import com.narbase.letsgo.web.routing.domain.admin.ridepromocodes.UpsertRidePromoCodeEndpoint
import com.narbase.letsgo.web.routing.domain.admin.rides.GetPassengerRidesEndpoint
import com.narbase.letsgo.web.routing.domain.admin.rides.GetRideByIdEndpoint
import com.narbase.letsgo.web.routing.domain.admin.rides.RequestRideAdminEndpoint
import com.narbase.letsgo.web.routing.domain.admin.staff.DeactivateAdminEndpoint
import com.narbase.letsgo.web.routing.domain.admin.staff.GetAdminsEndpoint
import com.narbase.letsgo.web.routing.domain.admin.staff.UpsertAdminsEndpoint
import com.narbase.letsgo.web.routing.domain.admin.support.GetSupportIssuesByCategoryEndpoint
import com.narbase.letsgo.web.routing.domain.admin.support.GetSupportListEndpoint
import com.narbase.letsgo.web.routing.domain.admin.support.UpsertSupportCategoryEndpoint
import com.narbase.letsgo.web.routing.domain.admin.support.UpsertSupportIssueEndpoint
import com.narbase.letsgo.web.routing.domain.admin.zones.GetPointZoneIdEndpoint
import com.narbase.letsgo.web.routing.domain.admin.zones.GetPriceZonesEndpoint
import com.narbase.letsgo.web.routing.domain.helloworld.HelloWorldEndPoint

/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] -[2019] Narbase Technologies
 * All Rights Reserved.
 * Created by islam
 * On: 2023/01/15.
 */
object AdminRouting : Routing() {
    override fun init() = api {
        "api_ep" {
            "public" {
                "v1" {
                }
            }
            "v1" {
                auth(Authentication.JWT)
                "admin" {
                    interceptor(IpLockInterceptor)
                    "login" { route(AdminLoginEndpoint) }
                    "profile" {
                        "details" { route(GetAdminProfileDetailsEndpoint) }
                    }
                    "admins" {
                        require(AdminPrivilege.StaffManagement)
                        "list" { route(GetAdminsEndpoint) }
                        "upsert" { route(UpsertAdminsEndpoint) }
                        "deactivate" { route(DeactivateAdminEndpoint) }
                    }
                    "drivers" {
                        "get_by_phone_number"{
                            route(GetDriverByPhoneEndpoint)
                        }
                        require(AdminPrivilege.DriversAccess)
                        "list" { route(GetDriversListEndpoint) }
                        require(AdminPrivilege.DriversManagement)
                        "privileged" {
                            "upsert" { route(UpsertDriverEndpoint) }
                        }
                        "driver_group" {
                            route(GetDriverGroupsByDriverEndpoint)
                        }
                    }
                    "dynamic_roles" {
                        "list" { route(GetAdminDynamicRolesEndpoint) }
                        "privileged" {
                            require(AdminPrivilege.DynamicRoles)
                            "upsert" { route(UpsertAdminDynamicRolesEndpoint) }
                            "delete" { route(DeleteAdminDynamicRoleEndpoint) }
                        }
                    }
                    "audit_log" {
                        require(AdminPrivilege.AuditLogAccess)
                        "get_audit_log" { route(GetAuditLogEndpoint) }
                    }
                    "driver_profile_groups" {
                        "list" { route(GetDriverProfileGroupsEndpoint) }
                        "privileged" {
                            require(AdminPrivilege.DriverProfileGroups)
                            "upsert" { route(UpsertDriverProfileGroupEndpoint) }
                        }
                    }
                    "passenger_profile_groups" {
                        "list" { route(GetPassengerProfileGroupsEndpoint) }
                        "privileged" {
                            require(AdminPrivilege.PassengerProfileGroups)
                            "upsert" { route(UpsertPassengerProfileGroupEndpoint) }
                        }
                    }
                    "driver_groups" {
                        "list" { route(GetDriverGroupsEndpoint) }
                        "privileged" {
                            "upsert" { route(UpsertDriverGroupEndpoint) }
                        }
                    }
                    "car_types" {
                        "list" { route(GetCarTypesEndpoint) }
                    }
                    "currencies" {
                        "list" { route(GetCurrenciesEndpoint) }
                    }
                    "passengers" {
                        "get" { route(GetPassengerByPhoneEndpoint) }
                        "get_by_id" { route(GetPassengerByIdEndpoint) }
                        "get_by_extension" { route(GetPassengerByVoipExtensionEndpoint) }
                    }
                    "phoneNumbers" {
                        "upsert" { route(UpsertPassengerPhoneNumbersEndpoint)}
                        "delete" { route(DeletePassengerPhoneNumberEndpoint)}
                        "list" { route(GetPassengerPhoneNumbersEndpoint)}
                    }
                    "call_center" {
                        "register_passenger" { route(RegisterPassengerByCallCenterEndpoint) }
                    }
                    "rides" {
                        "list" { route(GetPassengerRidesEndpoint) }
                        "request_ride" { route(RequestRideAdminEndpoint)}
                        "details" { route(GetRideByIdEndpoint)}
                        "rate_ride" { route(RateRideAdminEndpoint)}
                        "reorder_ride" { route(ReorderRideAdminEndpoint)}
                        "cancel_ride" { route(CancelRideAdminEndpoint)}
                        "update_ride_locations" { route(UpdateRideLocationsEndpoint)}
                        "get_latest"{ route(GetLatestPassengerRideEndpoint)}
                        "edit_rides" {
                            require(AdminPrivilege.RidesAccess)
                            "get_by_booking_key"{ route(GetRideByBookingKeyEndpoint)}
                            "complete_ride"{ route(CompleteRideAdminEndpoint)}
                        }
                    }
                    "favorite_points" {
                        "list" { route(GetPassengerFavoritePointsEndpoint) }
                        "create" { route(CreateFavoritePointEndpoint)}
                        "delete" { route(DeleteFavoritePointEndpoint)}
                        "search_index" {
                            require(AdminPrivilege.SearchIndexManagement)
                            "status" { route(GetFavoritePointsSearchStatusEndpoint) }
                            "reindex" { route(ReindexFavoritePointsSearchEndpoint) }
                        }
                    }
                    "push_payload" {
                        require(AdminPrivilege.PushPayloadSending)
                        "send" { route(SendPushPayloadEndpoint) }
                        "history" { route(GetPushSendHistoryEndpoint) }
                    }
                    "points_of_interest" {
                        "near_by" { route(GetNearbyPointsOfInterestEndpoint) }
                        "area" { route(GetAreaPointsOfInterestEndpoint) }
                        "search_index" {
                            require(AdminPrivilege.SearchIndexManagement)
                            "status" { route(GetPointsOfInterestSearchStatusEndpoint) }
                            "reindex" { route(ReindexPointsOfInterestSearchEndpoint) }
                            "search" { route(SearchPointsOfInterestEndpoint) }
                            "settings" { route(UpdateElasticsearchSettingsEndpoint) }
                        }
                    }
                    "prices" {
                        "by_car_types" { route(GetRidePricesEndpoint) }
                    }
                    "zone" {
                        "get_id" { route(GetPointZoneIdEndpoint) }
                        "list" { route(GetPriceZonesEndpoint) }
                    }
                    "location_points"{
                        "list" { route(GetPassengerLocationPointsEndpoint)}
                        "history_points" { route(GetHistoryPointsEndpoint)}
                    }
                    "call_center"{
                        "create"{ route(CreatePassengerForAdminEndpoint)}
                    }
                    "promo"{
                        "get_active"{ route(GetActivePromoCodesEndpoint)}
                        "deactivate"{ route(DeactivateRidePromoCodeEndpoint)}
                        "redeem"{ route(RedeemRidePromoCodeEndpoint)}
                        "list"{ route(GetRidePromoCodesEndpoint)}
                        "upsert"{ route(UpsertRidePromoCodeEndpoint)}
                    }
                    "incentives"{
                        "list"{ route(GetOrderingIncentivesEndpoint)}
                        "upsert"{ route(UpsertOrderingIncentivesEndpoint)}
                        "get_currency_incentive_configs"{ route(GetCurrencyIncentiveConfigsEndpoint)}
                        "upsert_currency_incentive_configs"{ route(UpsertCurrencyIncentiveConfigsEndpoint)}
                    }
                    "config"{
                        "get_config"{ route(GetConfigEndpoint)}
                        "upsert_config"{ route(UpsertConfigEndpoint)}
                    }
                    "mobile_update_config" {
                        require(AdminPrivilege.AppSettings)
                        "get" { route(GetMobileUpdateConfigEndpoint) }
                        "upsert" { route(UpsertMobileUpdateConfigEndpoint) }
                    }
                    "geocode" { route(GetGeocodeEndpoint)}
                    "recent_passenger_location" { route(GetPassengerLocationEndpoint)}
                    "place_types" {
                        "list" { route(GetPlaceTypesEndpoint) }
                    }
                    "driver_targets"{
                        require(AdminPrivilege.DriverTargets)
                        "get_targets"{ route(GetTargetsEndpoint)}
                        "upsert"{ route(UpsertTargetEndpoint)}
                    }
                    "bankily_transfers"{
                        require(AdminPrivilege.BankilyTransfers)
                        "list"{ route(GetBankilyTransfersEndpoint)}
                        "assign_driver"{ route(AssignTransferToDriverEndpoint)}
                    }
                    "areas" {
                        "list" {
                            route(GetAreasEndpoint)
                        }
                    }
                    "banners" {
                        "upsert" { route(UpsertBannerEndpoint) }
                        "get_list" { route(GetBannersEndpoint) }
                        "delete" { route(DeleteBannerEndpoint) }
                    }
                    "support" {
                        "get_list" { route(GetSupportListEndpoint) }
                        "get_issues" { route(GetSupportIssuesByCategoryEndpoint) }
                        "upsert_category" { route(UpsertSupportCategoryEndpoint) }
                        "upsert_issue" { route(UpsertSupportIssueEndpoint) }
                    }
                    "link_shares" {
                        require(AdminPrivilege.LinkShareManagement)
                        "logs" { route(GetLinkShareLogsEndpoint) }
                        "top_links" { route(GetLinkShareTopLinksEndpoint) }
                        "set_rewards_disabled" { route(SetLinkShareRewardsDisabledEndpoint) }
                        "settings" {
                            "list" { route(GetLinkShareRewardSettingsEndpoint) }
                            "upsert" { route(UpsertLinkShareRewardSettingEndpoint) }
                            "set_active" { route(SetLinkShareRewardSettingActiveEndpoint) }
                        }
                    }
                    "analytics" {
                        require(AdminPrivilege.InternalDeveloperConfig)
                        "settings" {
                            "get" { route(GetAnalyticsSettingsEndpoint) }
                            "upsert" { route(UpsertAnalyticsSettingsEndpoint) }
                        }
                    }
                    "voice_assistant" {
                        require(AdminPrivilege.AppSettings)
                        "settings" {
                            "get" { route(GetVoiceAssistantSettingsEndpoint) }
                            "upsert" { route(UpsertVoiceAssistantSettingsEndpoint) }
                        }
                        "models_health" { route(CheckVoiceAssistantModelsHealthEndpoint) }
                        "mcp_health" { route(CheckVoiceAssistantMcpHealthEndpoint) }
                        "engine_test" { route(TestVoiceAssistantEngineEndpoint) }
                        "provider_models" { route(ListVoiceAssistantProviderModelsEndpoint) }
                    }
                    "voice_assistant_sessions" {
                        require(AdminPrivilege.VoiceAssistantSessions)
                        "list" { route(GetVoiceAssistantSessionsEndpoint) }
                        "audio" { route(GetVoiceAssistantSessionAudioEndpoint) }
                    }
                }
            }
        }
    }
}